import CustomerDetails from 'components/customers/customerDetails';

const CustomerDetailsPage = () => {
  return <CustomerDetails />;
};

export default CustomerDetailsPage;
